"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _component = _interopRequireDefault(require("./component"));

var _each = _interopRequireDefault(require("lodash/each"));

var _querystring = _interopRequireDefault(require("querystring"));

// e.g. [
//   {
//     path: 'red',
//     label: 'Red',
//     items: [
//       {
//         path: 'light-red',
//         label: 'Light Red',
//         content: {
//           component: 'CollectionField',
//           form: {
//             component: 'org.proj.ColorField'
//           }
//         }
//       },
//       {
//         path: 'dark-red',
//         label: 'Dark Red'
//       }
//     ]
//   }
// ]
var Menu =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Menu, _Component);

  function Menu() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Menu)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'Menu');
    return _this;
  }

  (0, _createClass2.default)(Menu, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(Menu.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'items',
            component: 'CollectionField',
            formFactory: {
              component: 'Factory',
              product: {
                component: 'Form',
                fields: [{
                  name: 'path',
                  component: 'TextField',
                  label: 'Path',
                  required: true
                }, {
                  name: 'label',
                  component: 'TextField',
                  label: 'Label',
                  required: true
                }, {
                  name: 'content',
                  component: 'Field',
                  label: 'Content',
                  required: true
                }, {
                  name: 'fullScreen',
                  component: 'BooleanField',
                  label: 'Full Screen'
                }, {
                  name: 'roles',
                  component: 'RolesField',
                  label: 'Roles'
                }, {
                  name: 'hidden',
                  component: 'BooleanField',
                  label: 'Hidden'
                }]
              }
            }
          }]
        }
      });
    }
  }, {
    key: "_toRegExpPath",
    value: function _toRegExpPath(path) {
      var paramNames = [];
      var regExpPath = path.replace(/:([^/])*/g, function (match) {
        paramNames.push(match.substr(1));
        return '([^\\/]*)';
      });
      return {
        paramNames: paramNames,
        regExpPath: new RegExp('^' + regExpPath + '$')
      };
    }
  }, {
    key: "_indexItemByPath",
    value: function _indexItemByPath(item) {
      var _this2 = this;

      var extras = {};

      if (item.path) {
        extras = this._toRegExpPath(item.path);
      }

      this._itemsByPath[item.path] = (0, _objectSpread2.default)({}, item, extras);

      if (item.items) {
        item.items.forEach(function (item) {
          return _this2._indexItemByPath(item);
        });
      }
    }
  }, {
    key: "_indexByPath",
    value: function _indexByPath() {
      var _this3 = this;

      this._items.forEach(function (item) {
        return _this3._indexItemByPath(item);
      });
    }
  }, {
    key: "_indexParentByPath",
    value: function _indexParentByPath(item, parentItem) {
      var _this4 = this;

      this._parentsByPath[item.path] = parentItem;

      if (item.items) {
        item.items.forEach(function (childItem) {
          return _this4._indexParentByPath(childItem, item);
        });
      }
    }
  }, {
    key: "_indexParentsByPath",
    value: function _indexParentsByPath() {
      var _this5 = this;

      this._items.forEach(function (item) {
        return _this5._indexParentByPath(item);
      });
    }
  }, {
    key: "set",
    value: function set(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(Menu.prototype), "set", this).call(this, props); // Index by path so we can do a quick lookup later

      if (props.items !== undefined) {
        this._itemsByPath = {};

        this._indexByPath();

        this._parentsByPath = {};

        this._indexParentsByPath();
      }
    }
  }, {
    key: "getItemAndParsePath",
    value: function getItemAndParsePath(path) {
      var itemFound = null;
      var params = {};
      (0, _each.default)(this._itemsByPath, function (item) {
        if (item.path) {
          var match = path.match(item.regExpPath);

          if (match) {
            itemFound = item;
            item.paramNames.forEach(function (name, i) {
              return params[name] = match[i + 1];
            });
            return false; // exit loop
          }
        }
      });
      return {
        item: itemFound,
        params: params
      };
    }
  }, {
    key: "getItem",
    value: function getItem(path) {
      var _this$getItemAndParse = this.getItemAndParsePath(path),
          item = _this$getItemAndParse.item;

      return item;
    }
  }, {
    key: "toRoute",
    value: function toRoute(_ref) {
      var parameters = _ref.parameters,
          queryString = _ref.queryString,
          hash = _ref.hash;

      var query = _querystring.default.parse(queryString);

      return {
        parameters: parameters,
        query: query,
        hash: hash
      };
    }
  }, {
    key: "getParent",
    value: function getParent(path) {
      return this._parentsByPath[path];
    }
  }, {
    key: "getFirstItem",
    value: function getFirstItem() {
      return this._items[0];
    }
  }]);
  return Menu;
}(_component.default);

exports.default = Menu;